import './Navbar.css';
import { smoothScroll } from '../utils/smoothScroll';
import { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Define nav links with their corresponding section IDs
  const navLinks = [
    { id: 'Home', text: 'HOME' },
    { id: 'AboutUs', text: 'ABOUTUS' },
    { id: 'Why', text: 'OUR VALUE' },
    { id: 'Programs', text: 'PROGRAMS' },
    { id: 'Menu', text: 'MENU' },
    { id: 'Footer', text: 'CONTACT US' }
  ];

  const handleNavClick = (sectionId) => {
    smoothScroll(sectionId);
    setIsMenuOpen(false);
  };

  return (
    <div className="relative">
      <div className='flex items-center justify-between p-4 md:p-6 shadow-md'>
        {/* Logo */}
        <h1 className='ml-4 md:ml-8 font-handwriting text-2xl md:text-4xl'>
          <span className='text-green-600'>La</span>-<span className='text-orange-600'>Escondida</span>
        </h1>
        
        {/* Desktop Navlinks */}
        <nav className='hidden md:block pr-8'>
          <div className='flex gap-6 lg:gap-8 text-gray-800'>
            {navLinks.map(link => (
              <button 
                key={link.id}
                onClick={() => handleNavClick(link.id)}
                className="nav-button font-normal text-sm tracking-wide hover:text-green-600 transition-colors duration-300"
              >
                {link.text}
              </button>
            ))}
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden mr-4 p-2 text-gray-800 hover:text-green-600 transition-colors"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg z-50">
          <div className="flex flex-col p-4 space-y-4">
            {navLinks.map(link => (
              <button 
                key={link.id}
                onClick={() => handleNavClick(link.id)}
                className="nav-button-mobile text-left py-3 px-4 text-gray-800 hover:text-green-600 hover:bg-gray-50 rounded-lg transition-all duration-300 font-normal text-base"
              >
                {link.text}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;